// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".active[data-v-47965b1a]{color:#727cf5 !important}.drop[data-v-47965b1a]{position:relative;margin:0;display:inline-block}.drop svg[data-v-47965b1a]{transform:scale(0.7);transition:all ease-out .2s;pointer-events:none;min-width:25px;float:right}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
